// extracted by mini-css-extract-plugin
export var arrowLeft = "related-products-module--arrow-left--ZXzYq";
export var arrowRight = "related-products-module--arrow-right--Ehfz0";
export var buyNowButton = "related-products-module--buy-now-button--0rPLz";
export var container = "related-products-module--container--dlJM2";
export var grid = "related-products-module--grid--44Q7o";
export var swiperClass = "related-products-module--swiper-class--Gqwjj";
export var swiperContainer = "related-products-module--swiper-container--ketgm";
export var title = "related-products-module--title--eDj6K";